var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-card pointer",style:(`background-image: url('${_vm.url}'); aspect-ratio: ${_vm.ratio} `)})
}
var staticRenderFns = []

export { render, staticRenderFns }